export default __webpack_public_path__ + "static/media/icon-sort-active-up.9d46e8aa.svg";